import React from 'react'

import ReactWhatsapp from "react-whatsapp";
import mantasa from "../images/15gm.jpg";

import mantasagold from "../images/69.700gm.jpg";

import mantasa_8gmapprox from "../images/8.400gm.jpg";
import mantasambdhar from "../images/Mantasa gold.jpg";

import Mantasa_8gmapprox from "../images/8.110gm.jpg";
import mantasa8gm from "../images/8.680gm.jpg";
import mantasa_10gmapprox from "../images/Mantasa 10.460gm.jpg"
import mantasanew13 from "../images/8.780gm.jpg";
import Mantasa9_430gm from "../images/9.430gm.jpg";
import Mantasa9_770gm from "../images/9.770gm.jpg";
import mantasa9_860gm from "../images/9.860gm.jpg";


import mantasanew9_890gm from "../images/9.860gm.jpg";
import Mantasa9_890gm from "../images/9.890gm.jpg";
import Mantasa10_160gm from "../images/10.160gm.jpg";
import mantasa10_340gm from "../images/10.340gm.jpg";

import mantasanew13_620gm from "../images/13.620gm.jpg";
import Mantasa13_670gm from "../images/13.670gm.jpg";
import Mantasa14_950gm from "../images/14.950gm.jpg";
import mantasa15_770gm from "../images/15.770gm.jpg";


import mantasanew16_770gm from "../images/16.700gm.jpg";


import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import mantasanew from "../images/Mantasa 12.800gm.jpg";



function Mantasagold() {
    return (
        <div>
            <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={mantasa} className="card-img-top" alt="mantasa" />

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Mantasa </h5>
                                                <p className="card-text">Weight: 15gm</p>
                                                <p className="card-text">ID No.</p>

                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={mantasagold} className="card-img-top" alt="mantasagold" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Mantasa </h5>
                                                <p className="card-text">Weight: 10.050gm</p>
                                                <p className="card-text">ID No..</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={mantasa_8gmapprox} className="card-img-top" alt="Mantasa" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1">Mantasa </h5>
                                                <p className="card-text">Weight: 8.400gm</p>
                                                <p className="card-text">ID No.</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={mantasa_10gmapprox} className="card-img-top" alt="Mantasa" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >Mantasa                                     </h5>
                                                <p className="card-text">Weight: 10.460gm</p>
                                                <p className="card-text">ID No.</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                               
                                    <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img id="myimage" src={mantasanew} className="card-img-top" alt="Mantasa" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Mantasa </h5>
                                                <p className="card-text">Weight: 12.800gm</p>
                                                <p className="card-text">ID No.</p>

                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={mantasambdhar} className="card-img-top" alt="Mantasa" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Mantasa</h5>
                                                <p className="card-text">Weight: 18.220gm</p>
                                                <p className="card-text">ID No..</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={Mantasa_8gmapprox} className="card-img-top" alt="Mantasa" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1">Mantasa</h5>
                                                <p className="card-text">Weight: 8.110gm</p>
                                                <p className="card-text">ID No.</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={mantasa8gm} className="card-img-top" alt="Mantasa" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >Mantasa</h5>
                                                <p className="card-text">Weight: 8.680gm</p>
                                                <p className="card-text">ID No.</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img id="myimage" src={mantasanew13} className="card-img-top" alt="Mantasa" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Mantasa </h5>
                                                <p className="card-text">Weight: 8.780gm</p>
                                                <p className="card-text">ID No.</p>

                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="col-md-6  mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img src={Mantasa9_430gm} className="card-img-top" alt="Mantasa" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Mantasa</h5>
                                            <p className="card-text">Weight: 9.430gm</p>
                                            <p className="card-text">ID No..</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>
                                        </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img src={Mantasa9_770gm} className="card-img-top" alt="Mantasa" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1">Mantasa</h5>
                                            <p className="card-text">Weight: 9.770gm</p>
                                            <p className="card-text">ID No.</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img src={mantasa9_860gm} className="card-img-top" alt="Mantasa" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1" >Mantasa</h5>
                                            <p className="card-text">Weight: 9.860gm</p>
                                            <p className="card-text">ID No.</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>


            <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img id="myimage" src={mantasanew9_890gm} className="card-img-top" alt="Mantasa" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Mantasa </h5>
                                            <p className="card-text">Weight: 9.860gm</p>
                                            <p className="card-text">ID No.</p>

                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>


                                        </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="col-md-6  mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img src={Mantasa9_890gm} className="card-img-top" alt="Mantasa" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Mantasa</h5>
                                            <p className="card-text">Weight: 9.890gm</p>
                                            <p className="card-text">ID No..</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>
                                        </div>
                                    </div>
                                    </div>


                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img src={Mantasa10_160gm} className="card-img-top" alt="Mantasa"/>
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1">Mantasa</h5>
                                            <p className="card-text">Weight: 10.160gm</p>
                                            <p className="card-text">ID No.</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img src={mantasa10_340gm} className="card-img-top" alt="Mantasa" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1" >Mantasa</h5>
                                            <p className="card-text">Weight: 10.340gm</p>
                                            <p className="card-text">ID No.</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>


            <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img id="myimage" src={mantasanew13_620gm} className="card-img-top" alt="Mantasa" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Mantasa </h5>
                                            <p className="card-text">Weight: 13.620gm</p>
                                            <p className="card-text">ID No.</p>

                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>


                                        </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="col-md-6  mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img src={Mantasa13_670gm} className="card-img-top" alt="Mantasa" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Mantasa</h5>
                                            <p className="card-text">Weight: 13.670gm</p>
                                            <p className="card-text">ID No..</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>
                                        </div>
                                    </div>
                                    </div>


                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img src={Mantasa14_950gm} className="card-img-top" alt="Mantasa"/>
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1">Mantasa</h5>
                                            <p className="card-text">Weight: 14.950gm</p>
                                            <p className="card-text">ID No.</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img src={mantasa15_770gm} className="card-img-top" alt="Mantasa" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1" >Mantasa</h5>
                                            <p className="card-text">Weight: 15.770gm</p>
                                            <p className="card-text">ID No.</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            
            <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img id="myimage" src={mantasanew16_770gm} className="card-img-top" alt="Mantasa" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Mantasa </h5>
                                            <p className="card-text">Weight: 16.770gm</p>
                                            <p className="card-text">ID No.</p>

                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>


                                        </div>
                                        </div>
                                    </div>

                                </div>
                                

                            </div>
                        </div>
                       

                    </div>
                </div>
            </div>
            <br />

            <br />
        </div>
    )
}

export default Mantasagold